import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import Tag from '..';

interface Props {
  noIcon?: boolean;
}

const RejectedTag = ({ noIcon }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Tag icon={noIcon ? undefined : 'x'} color="red">
      {t('dashboard.card.reprovedTag')}
    </Tag>
  );
};

export default RejectedTag;
